import {
  GridColType,
  getGridDateOperators,
  getGridSingleSelectOperators,
  getGridBooleanOperators,
  getGridNumericOperators,
  getGridStringOperators,
  GridFilterModel,
} from '@mui/x-data-grid';

export const getDefaultOperators = (type: GridColType) => {
  if (type == 'number') return getGridNumericOperators();
  if (type == 'string') return getGridStringOperators();
  if (type == 'date') return getGridDateOperators();
  if (type == 'dateTime') return getGridDateOperators(true);
  if (type == 'boolean') return getGridBooleanOperators();
  if (type == 'singleSelect') return getGridSingleSelectOperators();
  return [];
};

export const parseFilterValue = (type: GridColType, value: string) => {
  if (type == 'number') return Number(value);
  if (type == 'boolean') return value == 'true';
  if (type == 'date' || type == 'dateTime') return new Date(value);
  if (type == 'singleSelect') return value;
  if (type == 'string') return value;
  if (type == 'actions') return value;
  return value;
};

export const mapFilterTypeToInputType = (type: GridColType) => {
  if (type == 'boolean') return 'boolean';
  if (type == 'number') return 'number';
  if (type == 'date' || type == 'dateTime') return 'date';
  return 'string';
};

export const getAppliedFiltersCount = (filterModel: GridFilterModel, skippedFields: string[] = []) => {
  const { items } = filterModel;
  const itemsWithSomeValue = items.filter(item => !skippedFields.includes(item.field) && item.value && item.value.length > 0);
  return itemsWithSomeValue.length;
};
